// extracted by mini-css-extract-plugin
module.exports = {"form":"AddYearModal_form_3fOnj","formError":"AddYearModal_formError_3DoEQ","formInput":"AddYearModal_formInput_dGCjc","formSubmission":"AddYearModal_formSubmission_18JaL"};